import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function Results() {
  const { t } = useTranslation();

  const results = [
    { icon: 'ri-line-chart-line', text: t('phoenix.results1') },
    { icon: 'ri-emotion-happy-line', text: t('phoenix.results2') },
    { icon: 'ri-robot-2-line', text: t('phoenix.results3') },
    { icon: 'ri-funds-line', text: t('phoenix.results4') },
    { icon: 'ri-user-star-line', text: t('phoenix.results5') },
    { icon: 'ri-speed-up-line', text: t('phoenix.results6') },
  ];

  return (
    <section className="relative py-20 md:py-28 bg-white">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <ScrollReveal direction="up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 border border-accent-200/50 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
            {t('phoenix.resultsTag')}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-16">
            Lo que vas a <span className="text-primary-500">lograr.</span>
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {results.map((item, i) => (
            <ScrollReveal key={i} direction="up" delay={i * 0.07}>
              <div className="group relative p-6 md:p-7 rounded-2xl bg-white border border-background-200/70 shadow-[0_2px_12px_rgba(0,0,0,0.03)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] hover:-translate-y-1 transition-all duration-400 cursor-default overflow-hidden">
                <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-primary-500/[0.04] to-transparent rounded-bl-3xl"></div>
                <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center mb-4 group-hover:bg-accent-100 transition-colors duration-300">
                  <i className={`${item.icon} text-accent-600 text-xl`}></i>
                </div>
                <p className="text-foreground-800 font-medium text-base">{item.text}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}